import React, { useMemo } from 'react';

import { ColumnDef } from '@tanstack/react-table';

import { KPI_COLUMN } from '../constants';

import { KPIData } from './useStatsTableData';

type AttributeValue = string;

interface UseColumnsProps {
  attributeValues: AttributeValue[];
}

export const useColumns = ({ attributeValues }: UseColumnsProps) => {
  return useMemo(() => {
    const baseColumns: ColumnDef<KPIData>[] = [
      {
        accessorKey: KPI_COLUMN.accessor,
        header: KPI_COLUMN.header,
        cell: ({ getValue }) => (
          <div className="font-medium text-base-mutedForeground">
            {getValue() as string}
          </div>
        )
      }
    ];

    const dynamicColumns: ColumnDef<KPIData>[] = attributeValues.map((attributeValue) => ({
      accessorKey: attributeValue,
      header: attributeValue,
      cell: ({ getValue }) => (
        <div className="text-base-foreground">
          {getValue() as string}
        </div>
      )
    }));

    return [...baseColumns, ...dynamicColumns];
  }, [attributeValues]);
}; 